import { render, staticRenderFns } from "./tablepagination.vue?vue&type=template&id=7a859d2c&scoped=true&"
import script from "./tablepagination.vue?vue&type=script&lang=js&"
export * from "./tablepagination.vue?vue&type=script&lang=js&"
import style0 from "./tablepagination.vue?vue&type=style&index=0&id=7a859d2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a859d2c",
  null
  
)

export default component.exports